import { FDHeadlineText } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * @deprecated Renamed for consistency. Please use HeadlineTextLarge from /FacetDesign/Components/Text instead.
 */
const HeadlineTextLarge = ({ value }) => {
  return <FDHeadlineText size="lg" value={value ?? ''} />;
};
HeadlineTextLarge.propTypes = { value: PropTypes.string.isRequired };

export default HeadlineTextLarge;
